import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ShipmentLabelChip from './ShipmentLabelChip';
import type { ShipmentLabelView } from '../../api/generated/models/ShipmentLabelView';

interface ShipmentBoardLabelFilterProps {
  labels: ShipmentLabelView[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

const ShipmentBoardLabelFilter: React.FC<ShipmentBoardLabelFilterProps> = ({
  labels,
  selected,
  onChange,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const toggle = (id: string) => {
    if (selected.includes(id)) {
      onChange(selected.filter((x) => x !== id));
    } else {
      onChange([...selected, id]);
    }
  };

  const label =
    selected.length === 0
      ? t('shipment_board_filter_labels')
      : t('shipment_board_filter_labels_count', { count: selected.length });

  return (
    <div className="shipment-status-filter shipment-board-label-filter" ref={ref}>
      <button
        className="btn btn-secondary shipment-status-filter__trigger"
        onClick={() => setOpen((o) => !o)}
        type="button"
      >
        {label}
        <span className="shipment-status-filter__arrow">{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <div className="shipment-status-filter__dropdown">
          {labels.length === 0 && (
            <p className="shipment-board-label-filter__empty">{t('shipment_board_filter_labels_empty')}</p>
          )}
          {labels.map((l) => (
            <label key={l.id} className="shipment-status-filter__option">
              <input
                type="checkbox"
                checked={selected.includes(l.id)}
                onChange={() => toggle(l.id)}
              />
              <ShipmentLabelChip label={l} />
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default ShipmentBoardLabelFilter;
